const ONE_WEEK = 60 * 60 * 24 * 7;

export default function useUtm() {
  const { getQueryParam } = useRouting();

  const utmSourceCookie = useCookie('utm_source', { maxAge: ONE_WEEK });
  const utmMediumCookie = useCookie('utm_medium', { maxAge: ONE_WEEK });
  const utmCampaignCookie = useCookie('utm_campaign', { maxAge: ONE_WEEK });
  const utmRefCookie = useCookie('utm_ref', { maxAge: ONE_WEEK });

  const queryUtm = {
    source: getQueryParam('utm_source') || '',
    medium: getQueryParam('utm_medium') || '',
    campaign: getQueryParam('utm_campaign') || '',
    ref: getQueryParam('ref') || ''
  };

  if (queryUtm.source) {
    utmSourceCookie.value = queryUtm.source;
  }
  if (queryUtm.medium) {
    utmMediumCookie.value = queryUtm.medium;
  }
  if (queryUtm.campaign) {
    utmCampaignCookie.value = queryUtm.campaign;
  }
  if (queryUtm.ref) {
    utmRefCookie.value = queryUtm.ref;
  }

  return {
    source: utmSourceCookie.value || '',
    medium: utmMediumCookie.value || '',
    campaign: utmCampaignCookie.value || '',
    ref: utmRefCookie.value || ''
  };
}